<div *ngIf="!bIconText" class="out txt" [ngClass]="{disabled:_disabled}" [style.border]="_border" [style.min-width.px]="min_width" [style.min-height.px]="min_height" [style.background]="_background" [style.color]="_color" [style.fontSize]="fontSize"
  [style.fontWeight]="fontWeight">
  <div *ngIf="text && !src_icon" class="center">{{text}}</div>
  <img *ngIf="src_icon && !text" class="abs_center" [src]="src_icon" />
</div>

<div *ngIf="bIconText" class="out txt div_tx_icon" [style.border]="_border" [style.min-width.px]="min_width" [style.min-height.px]="min_height" [style.background]="_background" [style.color]="_color" [style.fontSize]="fontSize" [style.fontWeight]="fontWeight">
  <div class="content">
    <img #img class="left" [ngClass]="{disabled:_disabled}" [src]="src_icon">
    <div class="icon_text" [ngClass]="{disabled:_disabled}">{{text}}</div>
  </div>
</div>
